import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';

import {environment} from '../../../environments/environment';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {AlertsService} from './alerts.service';
import {Router} from '@angular/router';
import {
  LOG_OUT_URL, REDIRECT_MANAGE, WARNING_MSG, WHATSAPP_SERVER_AUTH,
  CHECK_ACCOUNT_STATUS,
  WHATSAPP_TOKEN, WHATSAPP_SEND_TOKEN,
  SMS_AUTH,
  SMS_LS_ENTERPRISE_KEY,
  SMS_LS_FEEDNAME_KEY,
  SMS_LS_SENDERID_KEY,
  SMS_LS_PREPAID_ENTERPRISE_PRESENT_KEY,
  SMS_LS_INTERNATIONAL_FEED_STATUS_KEY
} from '../../config';
import {DataService} from './data.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class ApiService {
  private isDomainCardApiCalled = false;
  private _isDomainCardAdded = false;
  private isWaConfigApiCalled = false;
  private _isWaConfigAdded = false;
  constructor(private http: HttpClient,
              private alertsService: AlertsService,
              private router: Router, private dataservice : DataService) {
  }

  /**
   * This function makes get call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @returns Observable
   */
  get(path: string, params: any = ''): Observable<any> {
    const targetUrl = `${environment.api_url}${path}`;
    return Observable.create(observer => {
      this.http.get(targetUrl, params).subscribe(response => {
          // check if session out
          if (+response['status'] === 0) {
            this.redirectToLogout(LOG_OUT_URL);
          }
          // return data to caller
          observer.next(response);
          observer.complete();
        },
        // TODO : need to check invalid response on top header
        //     res => {
        //   this.alertsService.showP1Alert({
        //     type: 'warning',
        //     value: (res.error_info && res.error_info.message) || 'Invalid response'
        //   });
        //   if (!environment.production) {
        //     console.info(res);
        //   }
        // }
      );
    });
  }

  /**
   * This function makes post call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @param options Header Option
   * @returns Observable
   */
  post(path: string, params: any = '', options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  }): Observable<any> {
    const targetUrl = `${environment.api_url}${path}`;
    return Observable.create(observer => {
      this.http
        .post(targetUrl, params, options).subscribe(response => {
          // check if session out
          if (+response['status'] === 0) {
            this.redirectToLogout(LOG_OUT_URL);
          }
          // return data to caller
          observer.next(response);
          observer.complete();
        },
        //     res => {
        //   this.alertsService.showP1Alert({
        //     type: 'warning',
        //     value: (res.error_info && res.error_info.message) || 'Invalid response'
        //   });
        //   if (!environment.production) {
        //     console.info(res);
        //   }
        // }
      );
    });
  }
  //Change function name due to new api end point for whatapp
  /**
   * This function makes get call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @returns Observable
   */
  whatapp_get(path: string, params: any = {}): Observable<any> {
    const targetUrl = `${environment.whatspp_api_url}${path}`;
    params.withCredentials = true;
    return Observable.create(observer => {
      this.http.get(targetUrl, params).subscribe(response => {
          // check if session out
          if (+response['status'] === 0) {
            this.redirectToLogout(LOG_OUT_URL);
          }
          // return data to caller
          observer.next(response);
          observer.complete();
        },
        error => {
          // Handle HTTP errors properly
          console.error('HTTP Error in whatapp_get:', error);
          observer.error(error);
        }
      );
    });
  }

  /**
   * This function makes post call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @param options Header Option
   * @returns Observable
   */
  whatapp_post(path: string, data: any = {}, options: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  } = {}): Observable<any> {
    const targetUrl = `${environment.whatspp_api_url}${path}`;
    options.withCredentials = true;
    options.headers = new HttpHeaders({
      'Content-Type':  'application/json',
    });
    return Observable.create(observer => {
      this.http
        .post(targetUrl, data, options).subscribe(response => {
          // check if session out
          if (+response['status'] === 0) {
            this.redirectToLogout(LOG_OUT_URL);
          }
          // return data to caller
          observer.next(response);
          observer.complete();
        },
      );
    });
  }

  /**
   * This function makes post call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @param options Header Option
   * @returns Observable
   */
  whatapp_post_file(path: string, data: any = {}, options: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  } = {}): Observable<any> {
    const targetUrl = `${environment.whatspp_api_url}${path}`;
    options.withCredentials = true;
    return Observable.create(observer => {
      this.http
        .post(targetUrl, data, options).subscribe(response => {
          // check if session out
          if (+response['status'] === 0) {
            this.redirectToLogout(LOG_OUT_URL);
          }
          // return data to caller
          observer.next(response);
          observer.complete();
        },
      );
    });
  }

  /**
   * This function makes get call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @returns Observable
   */
  whatsapp_media_get(path: string, params: any = {}): Observable<any> {
    const targetUrl = `${environment.whatspp_api_url}${path}`;
    params.withCredentials = true;
    return Observable.create(observer => {
      this.http.get(targetUrl, params).subscribe(response => {
          // return data to caller
          observer.next(response);
          observer.complete();
        });
    });
  }


  redirectToLogout(url) {
    // clear user account type on logout
    this.cleanUpLocalStorageForSMS();
    // redirect to logout page
    // Fix: https://stackoverflow.com/questions/34338440/how-to-redirect-to-an-external-url-in-angular2/34340883
    // this.router.navigate(['/']).then(result => { commented to handle session timeout
    // localStorage.removeItem('whatsappToken');
    // this.dataservice.isWaTokenGenerated$.next(false);
    this.dataservice.clearWhatsAppToken();

      window.location.href = `${environment.api_url}${ LOG_OUT_URL}`;
    // });
  }

  getDomainCardStatus() {
    // call domain api
    this.get(REDIRECT_MANAGE)
      .subscribe((result) => {
        this.isDomainCardApiCalled = true;
        if (result['status'].toLowerCase() === 'success') {
          if (result['data']['flag'] === true) {
            this.isDomainCardApiCalled = true;
            this.router.navigate(['/getting-started/domain-wizard']);
          }
          this.setDomainStatus(!result['data']['flag']);
        } else {
          // this.type = 'danger';
          // this.msg = result['error_info']['message'];
        }
      });
  }

  setDomainStatus(val: boolean) {
    this.isDomainCardApiCalled = true;
    this._isDomainCardAdded = val;
  }

  isDomainCardAdded() {
    if (!this.isDomainCardApiCalled) {
      return true;
    } else {
      return this._isDomainCardAdded;
    }
  }

  fetchWithoutActivatUserDetails() {
    this.get(CHECK_ACCOUNT_STATUS)
      .subscribe(result => {
          if (result['status'] === 'success') {
            // this.accountStatus = result['data']['status'];
            // this.preferred_accountStatus = result['data']['pre_plan_status'];
            // this.whatsapp_enabled_sttaus = result['data']['wa_enable'];
            this.setWhatsAppStatus(result['data']['wa_enable']);
            // generate SMS token if enable
            if (result['data']['sms_enable']) {
              this.generateSMSToken();
            }
          }
        }
      );
  }

  setWhatsAppStatus(val: boolean) {
    this.isWaConfigApiCalled = true;
    this._isWaConfigAdded = Boolean(val);
    if (this._isWaConfigAdded)
      this.gettokeninfo();
  }

  isWaConfigAdded() {
    if (!this.isWaConfigApiCalled)
      return false;

    return this._isWaConfigAdded;
  }

  gettokeninfo()
  {
    const options = {withCredentials: true};
    this.get(WHATSAPP_TOKEN,options)
    .subscribe((result) => {
        if (result['status'] === 'success')
          this.sendtoken(result['data']['username'],result['data']['password'])
        else
          console.log('Somthing went wrong');
    },  error => {
        console.log('Internel Server Error');
    });
  }

  sendtoken(username='',password='')
  {
    const options = {withCredentials: true};
    let data = JSON.stringify({"username": username, "password": password});
    this.whatapp_post(WHATSAPP_SEND_TOKEN,data,options)
    .subscribe((result) => {
        if (result['code'] === 200){
          console.log(result['message']);
          this.dataservice.setWhatsappToken(true);
        }
        else{
          console.log('Somthing went wrong');
        }
    },  error => {
        console.log('Internel Server Error');
    });

  }

  /**
   * This function makes get call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @returns Observable
   */
  sms_get(path: string, params: any = {}): Observable<any> {
    const targetUrl = `${environment.sms_api_url}${path}`;
    params.withCredentials = true;

    return this.http.get(targetUrl, params).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle HTTP errors
        if (error.error instanceof ErrorEvent) {
          // Client-side or network error
          console.error('An error occurred:', error.error.message);
        } else {
          // Backend returned an unsuccessful response code
          console.error(
            `Backend returned code ${error.status}, body was: `, error.error);
        }

        // Check for session timeout
        if (error.error && error.error.status === 0) {
          this.redirectToLogout(LOG_OUT_URL);
          return throwError('Session timed out.'); // Propagate a message to the caller.
        }

        return throwError('Something went wrong! please try again later.');
      })
    );
  }

  /**
   * This function makes post call to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @param options Header Option
   * @returns Observable
   */
  sms_post(path: string, data: any = {}, options: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  } = {}): Observable<any> {
    const targetUrl = `${environment.sms_api_url}${path}`;
    options.withCredentials = true;
    options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(targetUrl, data, options).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle HTTP errors
        if (error.error instanceof ErrorEvent) {
          // Client-side or network error
          console.error('An error occurred:', error.error.message);
        } else {
          // Backend returned an unsuccessful response code
          console.error(
            `Backend returned code ${error.status}, body was: `, error.error);
        }

        // Check for session timeout
        if (error.error && error.error.status === 0) {
          this.redirectToLogout(LOG_OUT_URL);
          return throwError('Session timed out.'); // Propagate a message to the caller.
        }

        // Return an observable with a user-facing error message or a default value
        return throwError('Something bad happened; please try again later.');
      })
    );
  }

  /**
   * This function makes post call and submit file to api to given path and search params
   * @param path string
   * @param params URLSearchParams
   * @param options Header Option
   * @returns Observable
   */
  sms_post_file(path: string, data: any = {}, options: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  } = {}): Observable<any> {
    const targetUrl = `${environment.sms_api_url}${path}`;
    options.withCredentials = true;

    return this.http.post(targetUrl, data, options).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle HTTP errors
        if (error.error instanceof ErrorEvent) {
          // Client-side or network error
          console.error('An error occurred:', error.error.message);
        } else {
          // Backend returned an unsuccessful response code
          console.error(
            `Backend returned code ${error.status}, body was: `, error.error);
        }

        // Check for session timeout
        if (error.error && error.error.status === 0) {
          this.redirectToLogout(LOG_OUT_URL);
          return throwError('Session timed out.'); // Propagate a message to the caller.
        }

        // Return an observable with a user-facing error message or a default value
        return throwError('Something bad happened; please try again later.');
      })
    );
  }

  generateSMSToken() {
    // skip calling the API if token is generated
    if (localStorage.getItem('smsToken') === 'true') {
      this.dataservice.setSMSToken(true);
      return;
    }
    const options = { withCredentials: true };
    this.get(WHATSAPP_TOKEN, options).subscribe((result) => {
      if (result['status'] === 'success') {
        this.upsertSMSToken(result['data']);
      } else {
        console.log('Somthing went wrong');
      }
    }, error => {
      console.log('Internel Server Error');
    });
  }

  upsertSMSToken(data) {
    const payload = {
      "username": data.username,
      "password": data.password
    };
    // pass role_username if it exists
    if (data.role_username) {
      payload['role_username'] = data.role_username;
    }
    this.sms_post(SMS_AUTH, payload)
      .subscribe(result => {
        if (result['code'] === 200) {
          this.dataservice.setSMSToken(true);
        } else {
          console.log('Somthing went wrong');
        }
      }, (error) => {
        console.log('Internel Server Error');
      }
    );
  }

  cleanUpLocalStorageForSMS() {
    sessionStorage.removeItem('isSubUser');
    sessionStorage.removeItem('loginUserAccountType')
    localStorage.removeItem('smsToken');
    localStorage.removeItem(SMS_LS_ENTERPRISE_KEY);
    localStorage.removeItem(SMS_LS_FEEDNAME_KEY);
    localStorage.removeItem(SMS_LS_SENDERID_KEY);
    // Clear prepaid enterprise presence cache
    localStorage.removeItem(SMS_LS_PREPAID_ENTERPRISE_PRESENT_KEY);
    // Clear international feed status cache
    localStorage.removeItem(SMS_LS_INTERNATIONAL_FEED_STATUS_KEY);
  }
}
